import React from 'react';
import './_incident-key.scss';

const IncidentKey = () => (
  <div className="key">
    <div className="key__item key__label">Events Involving:</div>
    <div className="key__item key__civilian">
      <span className="key__icon key__icon--civilian" />
      Reported Civilian Deaths
    </div>
    {/*
    <div className="key__item key__child">
      <span className="key__icon key__icon--child" />
      Child Deaths
    </div>
    */}
    <div className="key__item key__nocivilian">
      <span className="key__icon key__icon--nocivilian" />
      No Reported Civilian Deaths
    </div>
  </div>
);

export default IncidentKey;
